import CollapseCard from "@components/miscellany/collapse/collapse_card"
import ColorPickerComponent from "./components/color_picker_component/color_picker_component"
import PositionComponent from "./components/position_component/position_component"
import VisibilityComponent from "./components/visibility_component/visibility_component"

export default function Progress(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this

    let colorPickerComponent, positionComponent, visibilityComponent

    this.generate = () =>{
        elements.container = this.createElement('div')
        elements.title_container = this.createElement('div','config-section-title mb-3','COMPONENTES ADICIONAIS')
        elements.collapse_container = this.createElement('div')
        elements.collapse_content = this.createElement('div')

        let collapse = new CollapseCard(
            {title_options:{text:'PROGRESS BAR', icon_options:{}, customClass: 'list-item-stations-title-wrapper'}, 
            content_options:{content: elements.collapse_content}
        })

        $(elements.collapse_container).html(collapse.generate())


        $(elements.container).append(elements.title_container,elements.collapse_container)

        setStage()
        generateColorPickerComponent()
        // generatePositionComponent()
        generateVisibilityComponent()

        $(container).html(elements.container)
    }

    this.update = () =>{

    }

    const setStage = _ =>{
        elements.row = this.createElement('div', 'flex flex-gap')
        elements.color_picker_container = this.createElement('div')
        elements.select_position_container = this.createElement('div')
        elements.visibility_container = this.createElement('div')
        $(elements.row).append(elements.color_picker_container, elements.select_position_container,elements.visibility_container)
        $(elements.collapse_content).append(elements.row)
    }

    const generateColorPickerComponent = _ =>{
        colorPickerComponent = new ColorPickerComponent({container: elements.color_picker_container})
        colorPickerComponent.generate()
    }

    const generatePositionComponent = _ =>{
        positionComponent = new PositionComponent({container: elements.select_position_container})
        positionComponent.generate()
    }

    const generateVisibilityComponent = _ =>{
        visibilityComponent = new VisibilityComponent({container: elements.visibility_container})
        visibilityComponent.generate()
    }
}

Progress.prototype = Object.create(BaseConstructor.prototype)